/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['li[_ngcontent-%COMP%]   .glyphicon[_ngcontent-%COMP%] {\r\n    margin-right: 10px;\r\n}\r\n\r\n\r\nli.link-active[_ngcontent-%COMP%]   a[_ngcontent-%COMP%], li.link-active[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]:hover, li.link-active[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]:focus {\r\n    background-color: #4189C7;\r\n    color: white;\r\n}\r\n\r\n\r\n.main-nav[_ngcontent-%COMP%] {\r\n    \r\n}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiZDovYS8xL3MvU29mdHdhcmVNYW5hZ2VyL0NsaWVudC9hcHAvY29tcG9uZW50cy9uYXZtZW51L25hdm1lbnUuY29tcG9uZW50LmNzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9kOi9hLzEvcy9Tb2Z0d2FyZU1hbmFnZXIvQ2xpZW50L2FwcC9jb21wb25lbnRzL25hdm1lbnUvbmF2bWVudS5jb21wb25lbnQuY3NzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// ./Client/$$_gendir/app/components/navmenu/navmenu.component.css.shim.ngstyle.ts